import React from 'react';
import { camelCase } from 'lodash';
import { Col, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import styles from './FormRow.scss';

const FormRow = props => {
  const {
    align,
    borderless,
    children,
    className,
    helpText,
    label,
    name,
    stacked,
    toggleContainer,
    labelCol,
    inputCol,
    tooltipContent,
  } = props;

  const htmlFor = name || (label && camelCase(label.replace(/\s+/, '')));

  return (
    <div
      className={classnames(
        className,
        styles.formRow,
        'form__form-group',
        { borderless, 'toggle-container': toggleContainer },
        stacked ? 'stacked' : 'horizontal'
      )}
    >
      <Row
        className={classnames('form-row', {
          'align-items-top': align === 'top',
          'align-items-center': align === 'center',
        })}
      >
        <Label
          className="form__form-group-label"
          htmlFor={htmlFor}
          md={stacked ? 12 : labelCol}
          xs={(toggleContainer && 'auto') || ''}
        >
          {label}{' '}
          {helpText && (
            <small className={classnames('help-text', { 'd-block': !stacked })}>
              {helpText}
            </small>
          )}
          {tooltipContent && (
            <span className="info-button">
              <FontAwesomeIcon icon={faExclamationCircle} />
              <span className="tooltip">{tooltipContent}</span>
            </span>
          )}
        </Label>
        <Col
          xs={(toggleContainer && 'auto') || 12}
          md={stacked ? 12 : inputCol}
        >
          <div className="input-container">{children}</div>
        </Col>
      </Row>
    </div>
  );
};

FormRow.propTypes = {
  align: PropTypes.oneOf(['top', 'center']),
  borderless: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  helpText: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  stacked: PropTypes.bool,
  toggleContainer: PropTypes.bool,
  labelCol: PropTypes.number,
  inputCol: PropTypes.number,
  tooltipContent: PropTypes.node,
};

FormRow.defaultProps = {
  align: 'center',
  borderless: false,
  className: null,
  helpText: '',
  stacked: false,
  toggleContainer: false,
  name: '',
  labelCol: 3,
  inputCol: 9,
  tooltipContent: null,
};

export default FormRow;
